import {createContext} from 'react'
import {DownTimeModalHandler} from 'types'

export const DownTimeModalContext = createContext<
  DownTimeModalHandler | undefined
>(undefined)
